import MonthPicker from "./MonthPicker";
import MultiMonthPicker from "./MultiMonthPicker";

export default function DateStatCard({
  mode = "single", // "single" | "month" | "month-multi"

  // single date mode is normal calendar date input
  value,
  onChange,

  // month mode
  monthValue,
  onChangeMonth,

  // month-multi mode
  monthValues,
  onChangeMonths,

  /** When true, user cannot select current or future months. Defaults false so financial/recon tabs allow future planning. */
  disableCurrentAndFuture = false,

  label = "Date",
  icon = "📅",
  /** Optional upper bound for the date input (YYYY-MM-DD). When omitted, future dates are allowed. */
  maxDate,
}) {
  return (
    <div className="bg-white rounded-2xl shadow-md p-4">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 flex items-center justify-center rounded-full bg-palette-indigo-muted text-palette-indigo-badge text-xl">
          {icon}
        </div>

        <div className="flex-1 min-w-0">
          <div className="text-xs text-palette-gray-secondary">{label}</div>

          {mode === "month" ? (
            <div className="mt-1">
              <MonthPicker
                value={monthValue}
                onChange={onChangeMonth}
                label={null}
                disableCurrentAndFuture={disableCurrentAndFuture}
              />
            </div>
          ) : mode === "month-multi" ? (
            <div className="mt-1">
              <MultiMonthPicker
                value={monthValues}
                onChange={onChangeMonths}
                disableCurrentAndFuture={disableCurrentAndFuture}
              />
            </div>
          ) : (
            <input
              type="date"
              value={value}
              max={maxDate || undefined}
              onChange={(e) => onChange?.(e.target.value)}
              className="mt-2 w-full max-w-[210px] rounded-xl border border-palette-gray-divider px-3 py-2 text-[15px] outline-none focus:ring-2 focus:ring-palette-indigo-label"
            />
          )}
        </div>
      </div>
    </div>
  );
}
